/* eslint-disable import/no-cycle */
import { call, put, takeEvery } from 'redux-saga/effects';
import { signin, phone } from '../../api/api';
import {
  CREATE_PHONE_CODE_SIGNIN,
  CREATE_PHONE_CODE_SIGNIN_SUCCESS,
  CREATE_TOKEN,
  CREATE_TOKEN_SUCCESS,
  CREATE_PHONE_CODE_SIGNIN_FAILURE
} from './signinActions';
import history from '../../router/history';
import logger from '../../utils/logger';

export function* createPhoneCode(action) {
  try {
    const response = yield call(phone.createPhoneCode, action.payload);
    if (response.data.success === true) {
      yield put({ type: CREATE_PHONE_CODE_SIGNIN_SUCCESS });
    } else {
      yield put({ type: CREATE_PHONE_CODE_SIGNIN_FAILURE });
    }
  } catch (error) {
    logger(error);
    yield put({ type: CREATE_PHONE_CODE_SIGNIN_FAILURE });
  }
}

export function* createToken(action) {
  try {
    const response = yield call(signin.createToken, action.payload);
    const account = {
      userHasTwoAccounts: !!(
        response.data.professional && response.data.individual
      ),
      accountType: 'particular',
      professionalToken: response.data.professional
        ? response.data.professional.token
        : null,
      individualToken: response.data.individual
        ? response.data.individual.token
        : null
    };
    if (response.data.success === true) {
      if (response.data.professional) {
        localStorage.setItem('token', response.data.professional.token);
        account.accountType = 'professional';
      } else {
        localStorage.setItem('token', response.data.individual.token);
        account.accountType = 'particular';
      }
      yield put({ type: CREATE_TOKEN_SUCCESS, payload: account });
      yield call(history.push, '/not-sent');
      yield put({ type: 'RESET_SIGNIN_REDUCER' });
    }
  } catch (error) {
    logger(error);
  }
}

const signinSaga = [
  takeEvery(CREATE_PHONE_CODE_SIGNIN, createPhoneCode),
  takeEvery(CREATE_TOKEN, createToken)
];

export default signinSaga;
